(function () {
    'use strict';

    var app = angular.module('inoApp');

    // Configure Toastr
    toastr.options.timeOut = 4000;
    toastr.options.positionClass = 'toast-bottom-right';

    var events = {
        appWorkStarted: 'app.workStarted',
        appWorkFinished: 'app.workFinished',
        auth: {
            logoutSuccess: 'auth-logout-success',
            notAuthenticated: 'auth-not-authenticated',
            notAuthorized: 'auth-not-authorized'
        },
        controllerActivateSuccess: 'controller.activateSuccess',
        languageChanged: 'languageChanged'
    };

    var config = {
        events: events,
        appRoot: angular.copy(window.appRootPath),
        clientAppSrcPath: angular.copy(window.clientAppSrcPath),
        appVersion: angular.copy(window.inoAppConfig.version),
        appLanguage: angular.copy(window.inoAppConfig.uiLanguage),
        servicesUrl: angular.copy(window.servicesUrl)
    };

    app.value('config', config);

    app.config(['commonConfigProvider', function (cfg) {
        cfg.config.appWorkStartedEvent = config.events.appWorkStarted;
        cfg.config.appWorkFinishedEvent = config.events.appWorkFinished;
        cfg.config.appRoot = config.appRoot;
        cfg.config.clientAppSrcPath = config.clientAppSrcPath;
    }]);
    
    app.config(['$logProvider', function ($logProvider) {
        // turn debugging off/on (no info or warn)
        if ($logProvider.debugEnabled) {
            $logProvider.debugEnabled(true);
        }
    }]);

    app.config(['tmhDynamicLocaleProvider', function (dynamicLocaleProvider) {
        dynamicLocaleProvider.localeLocationPattern(config.clientAppSrcPath + 'InovestorFramework/Core/i18n/angular-locale_{{locale}}.js');
        //dynamicLocale.set('en-CA');
    }]);
})();